import { INVITE_LINK_START_V01 } from "constants/constants";
import React, { useState } from "react";

function linkIsValid(link) {
  window.efs_debug &&
    window.log("Check if link is valid: " + JSON.stringify(link));
  return (
    typeof link === "string" &&
    link.length === INVITE_LINK_START_V01.length + 10 &&
    link.slice(0, INVITE_LINK_START_V01.length) === INVITE_LINK_START_V01
  );
}

function joinPastedLink(link) {
  window.location.href = link;
}

const JoinWithLink = () => {
  const [joinError, setJoinError] = useState(null);
  const [linkValue, setLinkValue] = useState("");

  function submitLink() {
    setJoinError(false);
    if (linkIsValid(linkValue)) joinPastedLink(linkValue);
    else setJoinError(true);
  }

  return (
    <div className="overflow-hidden">
      <div className={`text-nowrap`}>
        <div className="d-inline-block w-100">
          <input
            className="input-box"
            placeholder="Invite Link"
            type="text"
            onChange={(e) => {
              setJoinError(false);
              setLinkValue(e.target.value.trim());
            }}
            value={linkValue}
            onSubmit={submitLink}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                submitLink();
                e.preventDefault();
              }
            }}
          ></input>
          <div className="join-link-help">
            <div>Links are of the form:</div>
            <div>
              <em>{INVITE_LINK_START_V01}****</em>
            </div>
          </div>
          <button
            disabled={!linkValue}
            onClick={submitLink}
            type="submit"
            className="confirm-button business-button mt-1"
          >
            Try Join
          </button>
          {joinError && (
            <div className="server-response-error">
              This link is invalid. Please check that the form of the link
              matches that specified.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoinWithLink;
